import React from 'react';
import { connect } from 'react-redux';
import { Drawer, Form, Button, Col, Row, Input, Select, Radio, Switch, Divider, Table, Tag, Icon, Progress, Skeleton, message, Modal, Timeline, Tabs, Alert, Tooltip } from 'antd';
import { compare } from 'natural-orderby';
import moment from 'moment';

import InputMask from '../UI/InputMask';
import InputCurrency, { currency2Float, toBRL } from '../UI/InputCurrency';
import { DatePicker } from '../UI/DatePicker/Locale';
import Tip from '~/components/Tip';
import Download from '~/components/Components/Download';
import BillsForm from '~/containers/DrawerSocietario/Forms/BillsForm';
import RenewalWizard from './Components/RenewalWizard';
import Archive from './Includes/Archive';
import { loadCertificates, renewCertificate, loadCertificateHistory } from './actions';

var Option = Select.Option;
var TabPane = Tabs.TabPane;

class CerticatesForm extends React.Component {
    state = {
        default: {
            id: null,
            customer_id: null,
            owner_name: null,
            nature: null,
            type: null,
            document: null,
            fenacon: null,
            phone: null,
            emission_date: null,
            due_date: null,
            password: null,
            bird: false,
            amount: null,
        },
        activeForm: {},
        extras: [],
        extrasLoading: false,
        isBillsFormVisible: false,
        billsData: null,
        billsPayment: null,
        billsFormParams: {},
        history: [],
        historyLoading: false,
        renewLoading: false,
        renewWizardVisible: false,
        activeTab: 'overview',
        editDrawerVisible: false,
        financeiroDrawerVisible: false,
        historicoDrawerVisible: false,
        archiveVisible: false,
        showPassword: false,
        createStep: 0,
        createdCertId: null,
        createLoading: false,
    };

    onCreate = () => {
        const { form } = this.props;
        const context = this;

        form.validateFields((err, values) => {

            if (err) {
                return;
            }

            this.props.registerCertificate(values)
            .then(function(response) {
                form.resetFields();
                setTimeout(function() {
                    context.props.onClose();
                }, 0);
            });
        });

    }

    onSave = () => {
        const { form } = this.props;
        const context = this;

        form.validateFields((err, values) => {

            if (err) {
                return;
            }

            this.props.saveCertificate(this.props.data.id, {
                ...values,
                status: this.props.data.status
            })
            .then(function(response) {
                form.resetFields();
                setTimeout(function() {
                    context.props.onClose();
                }, 0);
            });
        });

    }

    loadExtras = () => {
        var context = this;
        var id = this.props.data && this.props.data.id;
        if (!id) return;

        this.setState({ extrasLoading: true });
        this.props.loadCertificateExtras(id)
            .then(function(response) {
                var extras = response.payload.data.data || [];
                // If there's a linked extra with installments, set it as billsPayment
                var latestExtra = extras.length > 0 ? extras[0] : null;
                var billsPayment = null;
                if (latestExtra && latestExtra.payments) {
                    billsPayment = {
                        id: latestExtra.id,
                        apuration_at: latestExtra.apuration_at,
                        installments: latestExtra.payments,
                        revised: latestExtra.revised
                    };
                }
                context.setState({ extras: extras, extrasLoading: false, billsPayment: billsPayment });
            })
            .catch(function(err) {
                console.error('loadExtras error:', err);
                context.setState({ extrasLoading: false, extras: [] });
            });
    }

    openBillForm = (params) => {
        this.setState({
            isBillsFormVisible: true,
            billsData: null,
            billsPayment: null,
            billsFormParams: params || {},
        });
    }

    getPaymentPercentage = () => {
        var payment = this.state.billsPayment;
        if (!payment || !payment.installments) return 0;
        var paid = payment.installments.filter(function(i) { return i.status === 'Pago'; }).length;
        return Math.round((100 * paid) / payment.installments.length);
    }

    onRenew = () => {
        var id = this.props.data && this.props.data.id;
        if (!id) return;
        this.setState({ renewWizardVisible: true });
    }

    onRenewConfirm = (wizardData) => {
        var context = this;
        var id = this.props.data && this.props.data.id;
        if (!id) return;

        this.setState({ renewLoading: true });
        this.props.dispatchRenewCertificate(id)
            .then(function(response) {
                var newCertData = response.payload.data.data;
                // Update the new certificate with all wizard data
                return context.props.saveCertificate(newCertData.id, {
                    emission_date: wizardData.emission_date,
                    due_date: wizardData.due_date,
                    scheduled_at: wizardData.scheduled_at,
                    amount: wizardData.amount,
                    status: 'registered',
                    nature: wizardData.nature,
                    type: wizardData.type,
                    owner_name: wizardData.owner_name,
                    document: wizardData.document,
                    fenacon: wizardData.fenacon,
                    password: wizardData.password,
                    bird: wizardData.bird,
                    notes: wizardData.notes,
                }).then(function(saveResponse) {
                    var savedData = saveResponse.payload.data.data;
                    // Generate billing if configured
                    if (wizardData.billing) {
                        return context.props.generateCertificateExtra(newCertData.id, {
                            amount: wizardData.amount,
                            due_date: wizardData.billing.billing_due_date,
                            payment_split: wizardData.billing.payment_split,
                            method: wizardData.billing.method,
                            cod: null,
                        }).then(function() { return savedData; });
                    }
                    return savedData;
                }).then(function(savedData) {
                    message.success('Certificado renovado com sucesso!');
                    context.setState({ renewLoading: false, renewWizardVisible: false });
                    context.props.form.resetFields();
                    context.props.onClose();
                    context.props.reloadCertificates();
                    // Open the new certificate in edit mode with updated data
                    if (savedData && context.props.showEdit) {
                        setTimeout(function() {
                            context.props.showEdit(savedData);
                        }, 300);
                    }
                });
            })
            .catch(function(err) {
                console.error('renew error:', err);
                message.error('Erro ao renovar certificado.');
                context.setState({ renewLoading: false });
            });
    }

    loadHistory = () => {
        var context = this;
        var id = this.props.data && this.props.data.id;
        if (!id) return;

        this.setState({ historyLoading: true });
        this.props.dispatchLoadHistory(id)
            .then(function(response) {
                var historyData = response.payload.data.data || [];
                context.setState({ history: historyData, historyLoading: false });
            })
            .catch(function(err) {
                console.error('loadHistory error:', err);
                context.setState({ historyLoading: false, history: [] });
            });
    }

    componentDidUpdate(prevProps) {
        // On open: load data and reset state
        if (this.props.visible && !prevProps.visible) {
            this.props.form.resetFields();
            this.setState({
                activeForm: {},
                extras: [],
                extrasLoading: false,
                history: [],
                historyLoading: false,
                activeTab: 'overview',
                showPassword: false,
                isBillsFormVisible: false,
                billsData: null,
                billsPayment: null,
                billsFormParams: {},
                renewLoading: false,
                renewWizardVisible: false,
                createStep: 0,
                createdCertId: null,
                createLoading: false,
            });
            if (this.props.data && this.props.data.id) {
                this.loadExtras();
                this.loadHistory();
            }
        }
        // On data change (switching between certificates)
        if (this.props.visible && prevProps.visible && this.props.data && prevProps.data && this.props.data.id !== prevProps.data.id) {
            this.props.form.resetFields();
            this.setState({ activeForm: {}, extras: [], history: [], activeTab: 'overview', showPassword: false });
            if (this.props.data.id) {
                this.loadExtras();
                this.loadHistory();
            }
        }
    }

    render() {
        var gfd = this.props.form.getFieldDecorator;
        var gfv = this.props.form.getFieldValue;
        var customers = this.props.customers;
        var activeCustomers = this.props.activeCustomers;
        var ctx = this;

        var data = Object.assign({}, this.state.default, this.props.data, this.state.activeForm);
        var isEdit = !!data.id;

        var currentCustomers = isEdit && data.customer_id && data.customer_id !== 'not_have'
            ? customers.filter(function(c) { return c.id === data.customer_id || (c.enabled === 1 && c.inactived_at === null); })
            : activeCustomers;

        var selectedCustomer = data.customer_id && data.customer_id !== 'not_have'
            ? customers.find(function(c) { return c.id === data.customer_id; })
            : null;

        var STATUS_COLORS = { 'Ativo': '#52c41a', 'Expirando': '#fa8c16', 'Expirado': '#f5222d', 'Arquivado': '#8c8c8c' };
        var statusColor = STATUS_COLORS[data.state] || '#d9d9d9';
        var daysLeft = data.expires_in != null ? Math.abs(data.expires_in) : null;
        var isExpired = data.state === 'Expirado';
        var isExpiring = data.state === 'Expirando';

        // Related certificates (active first, then archived)
        var relatedCerts = isEdit && data.customer_id && data.customer_id !== 'not_have'
            ? (this.props.allCertificates || []).filter(function(c) { return c.customer_id === data.customer_id; })
                .sort(function(a, b) {
                    var aArchived = a.archived_at ? 1 : 0;
                    var bArchived = b.archived_at ? 1 : 0;
                    if (aArchived !== bArchived) return aArchived - bArchived;
                    return (b.due_date || '').localeCompare(a.due_date || '');
                })
            : [];

        var handleClose = function() {
            ctx.props.form.resetFields();
            ctx.setState({ activeForm: {}, history: [], historyLoading: false, renewLoading: false, renewWizardVisible: false, editDrawerVisible: false, financeiroDrawerVisible: false, historicoDrawerVisible: false, archiveVisible: false, activeTab: 'overview', showPassword: false });
            ctx.props.onClose();
        };

        // Drawer title with status
        var drawerTitle = isEdit
            ? React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 10 } },
                React.createElement('span', null, 'Gerenciar Certificado'),
                React.createElement(Tooltip, { title: (data.state || 'Pendente') + (daysLeft != null ? ' · ' + daysLeft + ' dias' : '') },
                    React.createElement('span', { style: { display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12 } },
                        React.createElement('span', { style: { width: 8, height: 8, borderRadius: '50%', background: statusColor } }),
                        React.createElement('span', { style: { color: statusColor, fontWeight: 500 } }, data.state || 'Pendente')
                    )
                )
            )
            : 'Cadastrar Certificado';

        return (
        <React.Fragment>
        <div>
            <Drawer
                title={drawerTitle}
                width={isEdit ? 1100 : 620}
                placement="right"
                onClose={handleClose}
                maskClosable={false}
                visible={!!this.props.visible}
                destroyOnClose={true}
                key={this.props.visible ? 'open' : 'closed'}
                bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column', height: 'calc(100% - 55px)' }}
            >
            <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>

            {/* Left sidebar — Related certificates */}
            {isEdit && relatedCerts.length > 0 && (
            <div style={{ width: 200, flexShrink: 0, borderRight: '1px solid #f0f0f0', overflowY: 'auto', padding: '16px 12px', background: '#fafafa', position: 'relative', zIndex: 1 }}>
                <div style={{ fontSize: 10, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10, fontWeight: 600 }}>
                    Certificados ({relatedCerts.length})
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {(function() {
                        var activeCerts = relatedCerts.filter(function(c) { return !c.archived_at; });
                        var archivedCerts = relatedCerts.filter(function(c) { return !!c.archived_at; });
                        var renderCert = function(cert) {
                            var isCurrent = cert.id === data.id;
                            var isArchived = !!cert.archived_at;
                            var sc = STATUS_COLORS[cert.state] || '#d9d9d9';
                            var dl = cert.expires_in != null ? Math.abs(cert.expires_in) : null;
                            var ownerFull = cert.nature === 'PJ' ? (cert.customer_name || '') : (cert.owner_name || '');
                            var owner = ownerFull.length > 18 ? ownerFull.substring(0, 18) + '...' : ownerFull;
                            var dueTooltip = cert.due_date ? 'Vencimento: ' + moment(cert.due_date).format('DD/MM/YYYY') : 'Sem data de vencimento';
                            var archiveTooltip = isArchived ? (cert.archived_message || 'Arquivado') + (cert.archived_at ? ' em ' + moment(cert.archived_at).format('DD/MM/YYYY') : '') : '';
                            return React.createElement(Tooltip, {
                                key: cert.id,
                                title: (cert.type || '') + ' · ' + ownerFull + (isArchived ? ' · ' + archiveTooltip : ' · ' + (cert.state || 'Pendente')),
                                placement: 'right',
                                mouseEnterDelay: 0.4,
                            },
                            React.createElement('div', {
                                onClick: function() {
                                    if (!isCurrent && ctx.props.showEdit) {
                                        ctx.props.form.resetFields();
                                        ctx.setState({ activeForm: {}, history: [], extras: [], activeTab: 'overview' });
                                        ctx.props.showEdit(cert);
                                    }
                                },
                                style: {
                                    padding: '10px',
                                    borderRadius: isCurrent ? '8px 0 0 8px' : '8px',
                                    cursor: isCurrent ? 'default' : 'pointer',
                                    border: '1.5px solid ' + (isCurrent ? '#1890ff' : 'transparent'),
                                    borderRight: isCurrent ? 'none' : '1.5px solid transparent',
                                    marginRight: isCurrent ? -13 : 0,
                                    paddingRight: isCurrent ? 22 : 10,
                                    background: isCurrent ? '#fff' : '#fff',
                                    opacity: isArchived && !isCurrent ? 0.6 : 1,
                                    position: 'relative',
                                    zIndex: isCurrent ? 2 : 1,
                                    transition: 'all 0.2s',
                                    boxShadow: isCurrent ? '0 1px 4px rgba(24,144,255,0.12)' : 'none',
                                }
                            },
                                React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 3 } },
                                    React.createElement('span', { style: { fontSize: 12, fontWeight: 600, color: isCurrent ? '#1890ff' : '#262626' } }, cert.type || 'N/A'),
                                    React.createElement(Tooltip, { title: cert.state || 'Pendente' },
                                        React.createElement('span', { style: { width: 7, height: 7, borderRadius: '50%', background: sc, flexShrink: 0 } })
                                    )
                                ),
                                React.createElement('div', { style: { fontSize: 11, color: '#8c8c8c', marginBottom: 3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }, owner),
                                React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 10 } },
                                    React.createElement(Tooltip, { title: dueTooltip },
                                        cert.due_date
                                            ? React.createElement('span', { style: { color: '#595959' } }, moment(cert.due_date).format('DD/MM/YY'))
                                            : React.createElement('span', { style: { color: '#d9d9d9' } }, 'Sem data')
                                    ),
                                    isArchived
                                        ? React.createElement(Tooltip, { title: archiveTooltip },
                                            React.createElement('span', { style: { fontSize: 9, color: '#8c8c8c' } }, cert.archived_message || 'Arquivado')
                                          )
                                        : dl != null ? React.createElement(Tooltip, { title: dl + ' dias ' + (cert.state === 'Expirado' ? 'expirado' : 'para vencer') },
                                            React.createElement('span', { style: { fontWeight: 600, color: sc } }, dl + 'd')
                                          ) : null
                                )
                            ));
                        };
                        var items = activeCerts.map(renderCert);
                        if (archivedCerts.length > 0) {
                            items.push(React.createElement('div', { key: 'sep', style: { fontSize: 9, color: '#bfbfbf', textTransform: 'uppercase', letterSpacing: '0.05em', marginTop: 8, marginBottom: 4, fontWeight: 600, paddingLeft: 2 } }, 'Arquivados (' + archivedCerts.length + ')'));
                            items = items.concat(archivedCerts.map(renderCert));
                        }
                        return items;
                    })()}
                </div>
            </div>
            )}

            {/* Right content */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px 20px', borderLeft: isEdit && relatedCerts.length > 0 ? '1.5px solid #1890ff' : 'none' }}>


            {/* Customer info bar (edit mode) */}
            {isEdit && selectedCustomer && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', background: '#fafafa', borderRadius: 8, marginBottom: 16, border: '1px solid #f0f0f0' }}>
                <Icon type="shop" style={{ fontSize: 20, color: '#722ed1' }} />
                <div style={{ flex: 1 }}>
                    <Tooltip title={selectedCustomer.name + (selectedCustomer.identification_number ? ' · ' + selectedCustomer.identification_number : '')}>
                        <div style={{ fontSize: 14, fontWeight: 600, color: '#262626' }}>
                            {selectedCustomer.cod ? selectedCustomer.cod + ' - ' : ''}{selectedCustomer.name}
                        </div>
                    </Tooltip>
                    <Tooltip title={(data.type || 'Tipo não definido') + ' · ' + (data.nature === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica') + (data.owner_name ? ' · Titular: ' + data.owner_name : '')}>
                        <div style={{ fontSize: 12, color: '#8c8c8c' }}>
                            {data.type || 'Tipo não definido'} · {data.nature === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'}
                        </div>
                    </Tooltip>
                </div>
            </div>
            )}

            {/* Action cards */}
            {isEdit && !data.archived_at && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 20 }}>
                {[
                    { key: 'dados', icon: 'edit', color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff', label: 'Editar', desc: 'Alterar dados do certificado' },
                    { key: 'renew', icon: 'sync', color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f', label: 'Renovar', desc: isExpired ? 'Expirou há ' + Math.abs(data.expires_in) + ' dia' + (Math.abs(data.expires_in) !== 1 ? 's' : '') : isExpiring ? 'Expira em ' + daysLeft + ' dia' + (daysLeft !== 1 ? 's' : '') : 'Arquivar e criar novo' },
                    { key: 'pdf', icon: 'file-pdf', color: '#fa541c', bg: '#fff2e8', border: '#ffbb96', label: 'Gerar PDF', desc: 'Baixar certificado em PDF' },
                    data.customer_id && data.customer_id !== 'not_have' ? (function() {
                        var extras = ctx.state.extras || [];
                        if (extras.length > 0) {
                            var ex = extras[0];
                            var payments = ex.payments || [];
                            var paid = payments.filter(function(p) { return p.status === 'Pago'; }).length;
                            return { key: 'financeiro', icon: 'dollar', color: '#722ed1', bg: '#f9f0ff', border: '#d3adf7', label: 'Financeiro', desc: 'R$ ' + toBRL(ex.total || 0) + ' · ' + ex.payment_split + 'x · ' + paid + '/' + payments.length + ' pago' };
                        }
                        return { key: 'financeiro', icon: 'dollar', color: '#722ed1', bg: '#f9f0ff', border: '#d3adf7', label: 'Financeiro', desc: 'Vincular cobrança' };
                    })() : null,
                    ctx.state.history.length > 1 ? { key: 'historico', icon: 'history', color: '#fa8c16', bg: '#fff7e6', border: '#ffd591', label: 'Histórico', desc: ctx.state.history.length + ' renovações anteriores' } : null,
                    { key: 'archive', icon: 'inbox', color: '#8c8c8c', bg: '#f5f5f5', border: '#d9d9d9', label: 'Arquivar', desc: 'Arquivar este certificado' },
                ].filter(Boolean).map(function(action) {
                    var isActive = action.key !== 'renew' && action.key !== 'archive' && action.key !== 'pdf' && action.key !== 'financeiro' && action.key !== 'historico' && ctx.state.activeTab === action.key;
                    var cardEl = React.createElement('div', {
                        key: action.key,
                        onClick: action.key === 'pdf' ? undefined : function() {
                            if (action.key === 'dados') { ctx.setState({ editDrawerVisible: true }); }
                            else if (action.key === 'renew') { ctx.onRenew(); }
                            else if (action.key === 'archive') { ctx.setState({ archiveVisible: true }); }
                            else if (action.key === 'historico') { ctx.setState({ historicoDrawerVisible: true }); }
                            else if (action.key === 'financeiro') {
                                var extras = ctx.state.extras || [];
                                if (extras.length > 0) {
                                    var extra = extras[0];
                                    ctx.setState({ isBillsFormVisible: true, billsData: null, billsFormParams: { task_name: extra.task_name || ('Certificado Digital - ' + (data.type || '')), total: extra.total || 0 }, billsPayment: { id: extra.id, apuration_at: extra.apuration_at, installments: extra.payments, revised: extra.revised } });
                                } else {
                                    ctx.openBillForm({ task_name: 'Certificado Digital - ' + (data.type || ''), total: parseFloat(data.amount) || 0 });
                                }
                            }
                            else { ctx.setState({ activeTab: action.key }); }
                        },
                        style: {
                            width: 'calc(50% - 6px)', padding: '20px', borderRadius: 10, cursor: 'pointer',
                            border: '1.5px solid ' + (isActive ? action.color : '#e8e8e8'),
                            background: isActive ? action.bg : '#fff',
                            transition: 'all 0.2s',
                        },
                        onMouseEnter: function(e) { e.currentTarget.style.borderColor = action.border; e.currentTarget.style.background = action.bg; },
                        onMouseLeave: function(e) { if (!isActive) { e.currentTarget.style.borderColor = '#e8e8e8'; e.currentTarget.style.background = '#fff'; } },
                    },
                        React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 } },
                            React.createElement('div', { style: { width: 36, height: 36, borderRadius: 8, background: isActive ? action.color + '18' : '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                                React.createElement(Icon, { type: action.icon, style: { fontSize: 18, color: action.color } })
                            ),
                            React.createElement('span', { style: { fontSize: 16, fontWeight: 600, color: isActive ? action.color : '#262626' } }, action.label)
                        ),
                        React.createElement('div', { style: { fontSize: 13, color: '#8c8c8c', paddingLeft: 46 } }, action.desc)
                    );
                    if (action.key === 'pdf') {
                        var pdfName = (selectedCustomer ? selectedCustomer.name : 'certificado') + '_' + (data.type || '') + '.pdf';
                        return React.createElement(Download, { key: action.key, url: '/certificates/' + data.id + '/print', filename: pdfName }, cardEl);
                    }
                    return cardEl;
                })}
            </div>
            )}

            {/* Edit drawer (nested) */}
            {isEdit && (
            <Drawer
                title={React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
                    React.createElement(Icon, { type: 'edit', style: { color: '#1890ff' } }),
                    React.createElement('span', null, 'Editar Certificado')
                )}
                placement="right"
                width={620}
                visible={this.state.editDrawerVisible}
                onClose={function() { ctx.setState({ editDrawerVisible: false }); }}
                maskClosable={false}
                bodyStyle={{ padding: '20px 24px' }}
            >
                <Form layout="vertical">
                    <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, fontWeight: 600 }}>Certificado</div>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Natureza">
                                {gfd('nature', { initialValue: data.nature, rules: [{ required: true, message: 'Selecione' }] })(
                                    <Radio.Group onChange={function(e) { ctx.setState({ activeForm: { nature: e.target.value } }); }}>
                                        <Radio.Button value="PF">Pessoa Física</Radio.Button>
                                        <Radio.Button value="PJ">Pessoa Jurídica</Radio.Button>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Tipo">
                                {gfd('type', { initialValue: data.type, rules: [{ required: true, message: 'Selecione' }] })(
                                    <Select showSearch placeholder="Selecione" optionFilterProp="children"
                                        filterOption={function(input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; }}>
                                        <Option value="E-CPF A1">E-CPF A1</Option>
                                        <Option value="E-CPF A3">E-CPF A3</Option>
                                        <Option value="E-CNPJ A1">E-CNPJ A1</Option>
                                        <Option value="E-CNPJ A3">E-CNPJ A3</Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, marginTop: 4, fontWeight: 600 }}>Titular</div>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item label="Nome do Sócio" required={data.nature === 'PF'}>
                                {gfd('owner_name', { initialValue: data.owner_name, rules: data.nature === 'PF' ? [{ required: true, message: 'Obrigatório' }] : [] })(
                                    <Input placeholder="Nome do sócio" />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={data.nature === 'PF' ? 'CPF' : 'CNPJ'}>
                                {gfd('document', { initialValue: data.document })(
                                    <InputMask mask={data.nature === 'PF' ? "999.999.999-99" : "99.999.999/9999-99"} formatChars={{ "9": "[0-9]" }} maskChar={null}
                                        placeholder={data.nature === 'PF' ? "000.000.000-00" : "00.000.000/0000-00"} />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="FENACON">
                                {gfd('fenacon', { initialValue: data.fenacon })(<Input placeholder="FENACON" />)}
                            </Form.Item>
                        </Col>
                        {(data.customer_id === 'not_have' || !data.customer_id || data.phone) && (
                        <Col span={12}>
                            <Form.Item label="Telefone">
                                {gfd('phone', { initialValue: data.phone_formated })(
                                    <InputMask mask="(99) 9999tt999?" formatChars={{ "9": "[0-9]", "t": "[0-9\\-]", "?": "[0-9 ]" }} maskChar={null} placeholder="Telefone" />
                                )}
                            </Form.Item>
                        </Col>
                        )}
                    </Row>
                    <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, marginTop: 4, fontWeight: 600 }}>Datas</div>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item label="Emissão">
                                {gfd('emission_date', {
                                    initialValue: data.emission_date ? moment(data.emission_date, 'YYYY-MM-DD') : null,
                                    rules: data.status !== 'pendent' || (data.status === 'pendent' && !!gfv('due_date')) ? [{ required: true, message: 'Obrigatório' }] : [],
                                })(<DatePicker />)}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="Vencimento">
                                {gfd('due_date', {
                                    initialValue: data.due_date ? moment(data.due_date, 'YYYY-MM-DD') : null,
                                    rules: data.status !== 'pendent' || (data.status === 'pendent' && !!gfv('emission_date')) ? [{ required: true, message: 'Obrigatório' }] : [],
                                })(<DatePicker />)}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="Agendado para">
                                {gfd('scheduled_at', { initialValue: data.scheduled_at ? moment(data.scheduled_at, 'YYYY-MM-DD') : null })(<DatePicker />)}
                            </Form.Item>
                        </Col>
                    </Row>
                    <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, marginTop: 4, fontWeight: 600 }}>Outros</div>
                    <Row gutter={16}>
                        <Col span={16}>
                            <Form.Item label="Senha cadastrada">
                                {gfd('password', { initialValue: data.password })(
                                    <Input
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        placeholder="Senha"
                                        suffix={React.createElement(Icon, {
                                            type: this.state.showPassword ? 'eye' : 'eye-invisible',
                                            style: { cursor: 'pointer', color: '#8c8c8c' },
                                            onClick: function() { ctx.setState({ showPassword: !ctx.state.showPassword }); }
                                        })}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label={<span>BIRD <Tip>Renovação simplificada sem validação presencial.</Tip></span>}>
                                {gfd('bird', { valuePropName: 'checked', initialValue: !!data.bird })(<Switch />)}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Anotações">
                                {gfd('notes', { initialValue: data.notes })(<Input.TextArea rows={2} autoSize={{ minRows: 2, maxRows: 6 }} placeholder="Anotações" />)}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, borderTop: '1px solid #e8e8e8', padding: '12px 24px', background: '#fff', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button onClick={function() { ctx.setState({ editDrawerVisible: false }); }} style={{ borderRadius: 6 }}>Cancelar</Button>
                    <Button type="primary" style={{ borderRadius: 6 }} onClick={function() { ctx.onSave(); ctx.setState({ editDrawerVisible: false }); }}>Salvar</Button>
                </div>
            </Drawer>
            )}


            {/* Histórico drawer (nested) */}
            {isEdit && (
            <Drawer
                title={React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
                    React.createElement(Icon, { type: 'history', style: { color: '#fa8c16' } }),
                    React.createElement('span', null, 'Histórico'),
                    this.state.history.length > 1 && React.createElement('span', { style: { fontSize: 11, background: '#fa8c16', color: '#fff', borderRadius: 10, padding: '1px 8px', marginLeft: 6 } }, this.state.history.length)
                )}
                placement="right"
                width={620}
                visible={this.state.historicoDrawerVisible}
                onClose={function() { ctx.setState({ historicoDrawerVisible: false }); }}
                bodyStyle={{ padding: '20px 24px' }}
            >
                {this.state.historyLoading && <Skeleton active paragraph={{ rows: 3 }} title={false} />}
                {!this.state.historyLoading && this.state.history.length <= 1 && (
                    <div style={{ textAlign: 'center', padding: '32px 0', color: '#8c8c8c' }}>
                        <Icon type="safety-certificate" style={{ fontSize: 36, marginBottom: 8, display: 'block', color: '#d9d9d9' }} />
                        <div style={{ fontSize: 14, fontWeight: 500, color: '#595959', marginBottom: 4 }}>Primeiro certificado</div>
                        <div style={{ fontSize: 12, marginBottom: 12 }}>Nenhuma renovação anterior registrada.</div>
                        {data.emission_date && (
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12, padding: '8px 16px', background: '#f5f5f5', borderRadius: 6, fontSize: 12 }}>
                            <span><Icon type="calendar" style={{ marginRight: 4 }} />{moment(data.emission_date).format('DD/MM/YYYY')}</span>
                            <span style={{ color: '#d9d9d9' }}>→</span>
                            <span>{data.due_date ? moment(data.due_date).format('DD/MM/YYYY') : '-'}</span>
                            {data.amount ? <span style={{ color: '#389e0d', fontWeight: 500 }}>R$ {toBRL(data.amount)}</span> : null}
                        </div>
                        )}
                    </div>
                )}
                {!this.state.historyLoading && this.state.history.length > 1 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {this.state.history.map(function(item, idx) {
                        var isCurrent = item.id === data.id;
                        var isArchived = !!item.archived_at;
                        var emDate = item.emission_date ? moment(item.emission_date).format('DD/MM/YYYY') : '-';
                        var duDate = item.due_date ? moment(item.due_date).format('DD/MM/YYYY') : '-';
                        var sc2 = '#8c8c8c'; var sl = 'Pendente';
                        if (isArchived) { sc2 = '#8c8c8c'; sl = item.archived_message === 'Renovado' ? 'Renovado' : 'Arquivado'; }
                        else if (item.status === 'pendent') { sc2 = '#fa8c16'; sl = 'Pendente'; }
                        else if (item.state === 'Ativo') { sc2 = '#52c41a'; sl = 'Ativo'; }
                        else if (item.state === 'Expirando') { sc2 = '#faad14'; sl = 'Expirando'; }
                        else if (item.state === 'Expirado') { sc2 = '#f5222d'; sl = 'Expirado'; }
                        var duration = '';
                        if (item.emission_date && item.due_date) {
                            var months = moment(item.due_date).diff(moment(item.emission_date), 'months');
                            duration = months >= 12 ? Math.floor(months / 12) + ' ano' + (Math.floor(months / 12) > 1 ? 's' : '') : months + ' meses';
                        }
                        var borderColor = isCurrent ? '#1890ff' : isArchived ? '#e8e8e8' : sc2 + '40';
                        var bgColor = isCurrent ? '#e6f7ff' : isArchived ? '#fafafa' : '#fff';
                        var canClick = !isCurrent && !isArchived && ctx.props.showEdit;
                        return React.createElement('div', {
                            key: item.id,
                            onClick: function() { if (canClick) { ctx.props.form.resetFields(); ctx.setState({ activeForm: {}, history: [], extras: [], activeTab: 'overview', historicoDrawerVisible: false }); ctx.props.showEdit(item); } },
                            style: {
                                padding: '16px 20px', borderRadius: 10, cursor: canClick ? 'pointer' : 'default',
                                border: '1.5px solid ' + borderColor, background: bgColor,
                                opacity: isArchived && !isCurrent ? 0.75 : 1,
                                transition: 'all 0.2s',
                            },
                            onMouseEnter: function(e) { if (canClick) { e.currentTarget.style.borderColor = '#1890ff'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)'; } },
                            onMouseLeave: function(e) { if (canClick) { e.currentTarget.style.borderColor = borderColor; e.currentTarget.style.boxShadow = 'none'; } },
                        },
                            /* Header: status + tags */
                            React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 } },
                                React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
                                    React.createElement(Tag, { color: sc2, style: { margin: 0 } }, sl),
                                    isCurrent && React.createElement(Tag, { color: 'blue', style: { margin: 0 } }, 'Atual'),
                                    item.type && React.createElement(Tag, { style: { margin: 0 } }, item.type)
                                ),
                                item.amount ? React.createElement('span', { style: { fontSize: 16, fontWeight: 600, color: '#389e0d' } }, 'R$ ' + toBRL(item.amount)) : null
                            ),
                            /* Dates row */
                            React.createElement('div', { style: { display: 'flex', gap: 24, marginBottom: isArchived ? 0 : 12 } },
                                React.createElement('div', null,
                                    React.createElement('div', { style: { fontSize: 11, color: '#8c8c8c', marginBottom: 2 } }, 'Emissão'),
                                    React.createElement('div', { style: { fontSize: 14, fontWeight: 500, color: '#262626' } }, emDate)
                                ),
                                React.createElement('div', { style: { display: 'flex', alignItems: 'center', color: '#d9d9d9', fontSize: 16, paddingTop: 14 } }, '→'),
                                React.createElement('div', null,
                                    React.createElement('div', { style: { fontSize: 11, color: '#8c8c8c', marginBottom: 2 } }, 'Vencimento'),
                                    React.createElement('div', { style: { fontSize: 14, fontWeight: 500, color: '#262626' } }, duDate)
                                ),
                                duration && React.createElement('div', null,
                                    React.createElement('div', { style: { fontSize: 11, color: '#8c8c8c', marginBottom: 2 } }, 'Duração'),
                                    React.createElement('div', { style: { fontSize: 14, fontWeight: 500, color: '#595959' } }, duration)
                                )
                            ),
                            /* Footer: extra info */
                            !isArchived && item.owner_name ? React.createElement('div', { style: { fontSize: 12, color: '#8c8c8c', borderTop: '1px solid #f0f0f0', paddingTop: 10 } },
                                React.createElement(Icon, { type: 'user', style: { marginRight: 6 } }),
                                'Titular: ' + item.owner_name,
                                item.document ? React.createElement('span', { style: { marginLeft: 12 } }, React.createElement(Icon, { type: 'idcard', style: { marginRight: 4 } }), item.document) : null
                            ) : null,
                            isArchived && item.archived_at ? React.createElement('div', { style: { fontSize: 11, color: '#bfbfbf', marginTop: 8 } },
                                (item.archived_message || 'Arquivado') + ' em ' + moment(item.archived_at).format('DD/MM/YYYY')
                            ) : null
                        );
                    })}
                </div>
                )}
            </Drawer>
            )}

            {/* Tabs for edit mode */}
            {isEdit ? (
            <Tabs activeKey={this.state.activeTab} onChange={function(k) { ctx.setState({ activeTab: k }); }} style={{ marginTop: -8 }} tabBarStyle={{ display: 'none' }}>


            </Tabs>
            ) : (
            /* Create mode — 2 steps */
            <div>
                {/* Step indicator */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 0, marginBottom: 24 }}>
                    {[
                        { step: 0, label: 'Dados do certificado', icon: 'form' },
                        { step: 1, label: 'Financeiro', icon: 'dollar' },
                    ].map(function(s, idx) {
                        var isActive = ctx.state.createStep === s.step;
                        var isDone = ctx.state.createStep > s.step;
                        return React.createElement(React.Fragment, { key: s.step },
                            idx > 0 && React.createElement('div', { style: { flex: 1, height: 2, background: isDone || isActive ? '#1890ff' : '#e8e8e8', margin: '0 8px' } }),
                            React.createElement('div', {
                                onClick: function() { if (isDone) ctx.setState({ createStep: s.step }); },
                                style: {
                                    display: 'flex', alignItems: 'center', gap: 8, cursor: isDone ? 'pointer' : 'default',
                                    padding: '6px 14px', borderRadius: 20,
                                    background: isActive ? '#e6f7ff' : isDone ? '#f6ffed' : '#fafafa',
                                    border: '1.5px solid ' + (isActive ? '#1890ff' : isDone ? '#52c41a' : '#e8e8e8'),
                                    transition: 'all 0.2s',
                                }
                            },
                                React.createElement('span', {
                                    style: {
                                        width: 22, height: 22, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        background: isActive ? '#1890ff' : isDone ? '#52c41a' : '#d9d9d9', color: '#fff', fontSize: 12, fontWeight: 600,
                                    }
                                }, isDone ? React.createElement(Icon, { type: 'check', style: { fontSize: 11 } }) : (s.step + 1)),
                                React.createElement('span', { style: { fontSize: 13, fontWeight: isActive ? 600 : 400, color: isActive ? '#1890ff' : isDone ? '#52c41a' : '#8c8c8c' } }, s.label)
                            )
                        );
                    })}
                </div>

                {this.state.createStep === 0 && (
                <Form layout="vertical">
                    <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, fontWeight: 600 }}>Certificado</div>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Natureza">
                                {gfd('nature', { initialValue: data.nature, rules: [{ required: true, message: 'Selecione' }] })(
                                    <Radio.Group onChange={function(e) { ctx.setState({ activeForm: { nature: e.target.value } }); }}>
                                        <Radio.Button value="PF">Pessoa Física</Radio.Button>
                                        <Radio.Button value="PJ">Pessoa Jurídica</Radio.Button>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Tipo">
                                {gfd('type', { initialValue: data.type, rules: [{ required: true, message: 'Selecione' }] })(
                                    <Select showSearch placeholder="Selecione" optionFilterProp="children"
                                        filterOption={function(input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; }}>
                                        <Option value="E-CPF A1">E-CPF A1</Option>
                                        <Option value="E-CPF A3">E-CPF A3</Option>
                                        <Option value="E-CNPJ A1">E-CNPJ A1</Option>
                                        <Option value="E-CNPJ A3">E-CNPJ A3</Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, marginTop: 4, fontWeight: 600 }}>Cliente</div>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item label="Empresa">
                                {gfd('customer_id', { initialValue: null, rules: [{ required: true, message: 'Selecione' }] })(
                                    <Select showSearch placeholder="Selecione uma empresa" optionFilterProp="children"
                                        onChange={function(val) { ctx.setState({ activeForm: Object.assign({}, ctx.state.activeForm, { customer_id: val }) }); }}
                                        filterOption={function(input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; }}>
                                        <Option value="not_have">Não possui ou não é cliente</Option>
                                        {currentCustomers.map(function(row) {
                                            var isInactive = row.enabled !== 1 || row.inactived_at !== null;
                                            var cname = row.cod ? row.cod + ' - ' + row.name : row.name;
                                            return <Option value={row.id} key={row.id} disabled={isInactive}>{isInactive ? cname + ' (INATIVA)' : cname}</Option>;
                                        })}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Nome do Sócio" required={data.nature === 'PF'}>
                                {gfd('owner_name', { initialValue: data.owner_name, rules: data.nature === 'PF' ? [{ required: true, message: 'Obrigatório' }] : [] })(<Input placeholder="Nome do sócio" />)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={data.nature === 'PF' ? 'CPF' : 'CNPJ'}>
                                {gfd('document', { initialValue: data.document })(
                                    <InputMask mask={data.nature === 'PF' ? "999.999.999-99" : "99.999.999/9999-99"} formatChars={{ "9": "[0-9]" }} maskChar={null}
                                        placeholder={data.nature === 'PF' ? "000.000.000-00" : "00.000.000/0000-00"} />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="FENACON">
                                {gfd('fenacon', { initialValue: data.fenacon })(<Input placeholder="FENACON" />)}
                            </Form.Item>
                        </Col>
                        {(data.customer_id === 'not_have' || !data.customer_id) && (
                        <Col span={12}>
                            <Form.Item label="Telefone">
                                {gfd('phone', { initialValue: data.phone_formated })(
                                    <InputMask mask="(99) 9999tt999?" formatChars={{ "9": "[0-9]", "t": "[0-9\\-]", "?": "[0-9 ]" }} maskChar={null} placeholder="Telefone" />
                                )}
                            </Form.Item>
                        </Col>
                        )}
                    </Row>
                    <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, marginTop: 4, fontWeight: 600 }}>Datas</div>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item label="Emissão" required>
                                {gfd('emission_date', { initialValue: null, rules: [{ required: true, message: 'Obrigatório' }] })(<DatePicker />)}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="Vencimento" required>
                                {gfd('due_date', { initialValue: null, rules: [{ required: true, message: 'Obrigatório' }] })(<DatePicker />)}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="Agendado para">
                                {gfd('scheduled_at', { initialValue: null })(<DatePicker />)}
                            </Form.Item>
                        </Col>
                    </Row>
                    <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, marginTop: 4, fontWeight: 600 }}>Outros</div>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item label="Senha">
                                {gfd('password', { initialValue: data.password })(<Input placeholder="Senha" />)}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Anotações">
                                {gfd('notes', { initialValue: data.notes })(<Input.TextArea rows={2} autoSize={{ minRows: 2, maxRows: 6 }} placeholder="Anotações" />)}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label={<span>BIRD <Tip>Renovação simplificada sem validação presencial.</Tip></span>}>
                                {gfd('bird', { valuePropName: 'checked', initialValue: !!data.bird })(<Switch />)}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                )}

                {this.state.createStep === 1 && (
                <div>
                    <div
                        onClick={function() {
                            ctx.openBillForm({ task_name: 'Certificado Digital - ' + (gfv('type') || data.type || ''), total: 0 });
                        }}
                        style={{
                            border: '2px dashed #d9d9d9', borderRadius: 8, padding: '28px 20px',
                            textAlign: 'center', cursor: 'pointer', transition: 'all 0.2s', background: '#fafafa',
                        }}
                        onMouseEnter={function(e) { e.currentTarget.style.borderColor = '#1890ff'; e.currentTarget.style.background = '#f0f7ff'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.borderColor = '#d9d9d9'; e.currentTarget.style.background = '#fafafa'; }}
                    >
                        <Icon type="plus-circle" style={{ fontSize: 32, color: '#bfbfbf', marginBottom: 8, display: 'block' }} />
                        <div style={{ fontSize: 14, fontWeight: 500, color: '#595959', marginBottom: 4 }}>Vincular cobrança</div>
                        <div style={{ fontSize: 12, color: '#8c8c8c' }}>Clique para definir valor, parcelas e forma de pagamento</div>
                    </div>
                    <div style={{ marginTop: 16, padding: '12px 16px', background: '#f6ffed', borderRadius: 6, border: '1px solid #b7eb8f', fontSize: 12, color: '#389e0d' }}>
                        <Icon type="info-circle" style={{ marginRight: 6 }} />
                        Este passo é opcional. Você pode gerar a cobrança depois editando o certificado.
                    </div>
                </div>
                )}
            </div>
            )}

            <BillsForm
                visible={this.state.isBillsFormVisible}
                setVisible={function(val) { ctx.setState({ isBillsFormVisible: val }); if (!val) { ctx.loadExtras(); ctx.props.reloadCertificates(); } }}
                billsData={this.state.billsData}
                setBillsData={function(val) {
                    if (val) {
                        var payments = val.payments ? Object.values(val.payments) : [];
                        var paymentData = {
                            amount: val.total,
                            due_date: payments.length > 0 ? (payments[0].due_date && payments[0].due_date.format ? payments[0].due_date.format('YYYY-MM-DD') : payments[0].due_date) : moment().format('YYYY-MM-DD'),
                            payment_split: val.payment_split || payments.length || 1,
                            method: payments.length > 0 ? payments[0].method : 2,
                            cod: null,
                        };
                        ctx.props.generateCertificateExtra(ctx.state.createdCertId || data.id, paymentData)
                            .then(function() { message.success('Cobrança gerada!'); ctx.setState({ billsData: null, isBillsFormVisible: false }); ctx.loadExtras(); ctx.props.reloadCertificates(); })
                            .catch(function() { message.error('Erro ao gerar cobrança.'); });
                    } else {
                        ctx.setState({ billsData: null });
                    }
                }}
                setBillsPayment={function(val) { ctx.setState({ billsPayment: val }); ctx.loadExtras(); }}
                billsPayment={this.state.billsPayment}
                data={Object.assign({}, this.state.billsFormParams || {}, { customer_id: data.customer_id, id: this.state.createdCertId || data.id })}
                user={this.props.user}
            />

            </div>
            </div>

            {/* Sticky footer */}
            <div style={{
                borderTop: '1px solid #e8e8e8', padding: '12px 24px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                background: '#fff', flexShrink: 0,
            }}>
                <div></div>
                <div style={{ display: 'flex', gap: 8 }}>
                    <Button onClick={handleClose} style={{ borderRadius: 6 }}>{isEdit ? 'Fechar' : 'Cancelar'}</Button>
                    {!isEdit && (this.state.createStep === 0
                            ? <Button type="primary" style={{ borderRadius: 6 }} loading={this.state.createLoading} onClick={function() {
                                ctx.props.form.validateFields(function(err, values) {
                                    if (err) return;
                                    ctx.setState({ createLoading: true });
                                    ctx.props.registerCertificate(values)
                                        .then(function(response) {
                                            var newCert = response.payload.data.data || response.payload.data;
                                            var newId = newCert && newCert.id;
                                            message.success('Certificado cadastrado!');
                                            ctx.setState({ createStep: 1, createdCertId: newId, createLoading: false });
                                            ctx.props.reloadCertificates();
                                        })
                                        .catch(function() {
                                            message.error('Erro ao cadastrar.');
                                            ctx.setState({ createLoading: false });
                                        });
                                });
                              }}>Cadastrar e continuar <Icon type="right" /></Button>
                            : <Button onClick={handleClose} type="primary" style={{ borderRadius: 6 }}>Concluir</Button>
                    )}
                </div>
            </div>
            </Drawer>
            </div>
            {this.state.archiveVisible && isEdit && (
                <Archive
                    data={data}
                    onClose={function() { ctx.setState({ archiveVisible: false }); }}
                    saveCertificate={function() { ctx.props.reloadCertificates(); handleClose(); }}
                />
            )}
            <RenewalWizard
                visible={this.state.renewWizardVisible}
                onClose={function() { ctx.setState({ renewWizardVisible: false }); }}
                certificate={data}
                onConfirm={this.onRenewConfirm}
                renewLoading={this.state.renewLoading}
            />
        </React.Fragment>
        );
    }
}


const mapDispatchProps = dispatch => {
    return{
        registerCertificate: (data) => dispatch({
        type: 'REGISTER_CERTIFICATE',
        payload: {
          request:{
            method: 'post',
            url:'/certificates',
            data: data
          }
        }
      }),
      saveCertificate: (id, data) => dispatch({
        type: 'SAVE_CERTIFICATE',
        payload: {
          request:{
            method: 'post',
            url:'/certificates/' + id,
            data: data
          }
        }
      }),
      loadCertificateExtras: (id) => dispatch({
        type: 'LOAD_CERTIFICATE_EXTRAS',
        payload: {
          request:{
            method: 'get',
            url: '/certificates/' + id + '/extras',
            showLoading: false,
          }
        }
      }),
      generateCertificateExtra: (id, data) => dispatch({
        type: 'GENERATE_CERTIFICATE_EXTRA',
        payload: {
          request:{
            method: 'post',
            url: '/certificates/' + id + '/extras',
            data: data,
            showLoading: false,
          }
        }
      }),
      reloadCertificates: () => dispatch(loadCertificates({ showLoading: false })),
      dispatchRenewCertificate: (id) => dispatch(renewCertificate(id)),
      dispatchLoadHistory: (id) => dispatch(loadCertificateHistory(id))
    }
}

const mapStateToProps = state => {
    return {
        customers: state.customers.list.filter(row => row.is_customer).sort((a,b) => compare()(a.cod, b.cod)),
        activeCustomers: state.customers.list.filter(row => row.enabled === 1 && row.inactived_at === null && row.is_customer).sort((a,b) => compare()(a.cod, b.cod)),
        user: state.user,
        allCertificates: state.certificates.list || [],
    }
}
  
export default connect(mapStateToProps, mapDispatchProps)(Form.create()(CerticatesForm));